'use strict';
define([], function () {
    var PATTERNS = {
        cf: /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i,
        destinationCode: /[a-zA-Z0-9]{7}/,
        vat: /^((AT)U[0-9]{8}|(BE)0[0-9]{9}|(BG)[0-9]{9,10}|(CY)[0-9]{8}[A-Z]|(CZ)[0-9]{8,11}|(DE)[0-9]{9}|(DK)[0-9]{8}|(EE)[0-9]{9}|(EL|GR)[0-9]{9}|(ES)[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)[0-9]{8}|(FR)[0-9A-Z]{2}[0-9]{9}|(GB)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)[0-9]{8}|(IE)[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)([0-9]{9}|[0-9]{12})|(LU)[0-9]{8}|(LV)[0-9]{11}|(MT)[0-9]{8}|(NL)[0-9]{9}B[0-9]{2}|(PL)[0-9]{10}|(PT)[0-9]{9}|(RO)[0-9]{2,10}|(SE)[0-9]{12}|(SI)[0-9]{8}|(SK)[0-9]{10})$/i,
        email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    };

    function Controller($rootScope, $scope, __env, $timeout, $state, $stateParams, UserService, CountriesService, TaxService, CheckoutService, plan, infoUser, isTrialing, $translate, $filter, coupon, $window, ItalyService, $cookies, $q, TrackEventService, $mdMedia, AuthService, Facebook, PlanDetailsService, LanguageService, SuiteTheme, CRMService) {
        var vm = $scope;
        vm.patterns = PATTERNS;
        var default_country = 'US';
        if ($translate.instant('currentLangCode').indexOf('it') !== -1) default_country = 'IT';
        var referral = $cookies.get('storeferral');

        removePromoCouponIfExpired();

        vm.steps = {
            country: {
                show: false, exist: false, hide: true
            }, details: {
                show: true, exist: true, hide: false
            }, payment: {
                show: false, exist: false, hide: false
            }
        };

        vm.loading = {
            payment: false
        };
        vm.authLoading = false;
        vm.socialLoading = null;
        vm.socialError = false;
        vm.quickLoginMode = false;
        vm.isTrialing = isTrialing;
        vm.filterData = {
            trialEndOn: getDateSubEnd(plan, isTrialing), subscriptionEndAt: getDateSubEnd(plan, isTrialing)
        };
        vm.trialEndOn = getDateSubEnd(plan, isTrialing);
        vm.italy = ItalyService.all();
        vm.requiredVat = false;
        vm.requiredBusinessName = false;
        vm.afterPaidLoading = false;
        vm.errorVat = false;
        vm.plan = plan;
        vm.checkoutPlanName = vm.plan.name;
        vm.plan.amountDecimal = null;
        vm.price = {
            loading: true,
            error: null,
            data: null
        };
        vm.currencySymbol = getCurrencySymbol(vm.plan.currency);
        vm.trialDays = vm.isTrialing ? (vm.plan.trialPeriodDays || 7) : 0;
        vm.getTrialPriceMessage = getTrialPriceMessage;
        vm.totalCheckout = 0;
        vm.subtotalCheckout = 0;
        vm.totalDueToday = 0;
        vm.tax = 0;
        vm.thisTax = 0;
        var promoPreview = PlanDetailsService.getPromoPreview();
        var currentPromo = PlanDetailsService.isPromoTime() ? PlanDetailsService.getCurrentPromo() : null;
        vm.$mdMedia = $mdMedia;
        vm.hasCard = null;
        vm.countries = CountriesService;
        vm.currentPromo = currentPromo;
        vm.isPromoTime = !!currentPromo && currentPromo.promoType === 'all-platform-promo';
        vm.allLanguages = $translate.getAvailableLanguageKeys();
        vm.selectedLang = LanguageService.getCodeAndCountrySaveOnStorage();
        vm.themePreference = SuiteTheme.getPreference();
        vm.cycleThemePreference = cycleThemePreference;
        vm.switchLang = switchLang;
        vm.hasOrderTax = hasOrderTax;
        vm.unsetCoupon = unsetCoupon;
        vm.showCouponEditor = showCouponEditor;
        vm.goToBillingDetails = goToBillingDetails;
        vm.quickSignin = quickSignin;
        vm.enableQuickLogin = enableQuickLogin;
        vm.enableSignup = enableSignup;
        vm.loginFacebook = loginFacebook;

        /**
         * Check Exist on URL the params Deal Id
         */
        if ($stateParams.dealId) {
            checkOnLocalStorage('dealId', $stateParams.dealId);
        }

        if ($stateParams.saleOwner) {
            checkOnLocalStorage('saleOwner', $stateParams.saleOwner);
        }

        vm.isAuthenticated = AuthService.isAuthenticated();

        if (vm.isAuthenticated) {
            var user = AuthService.getSessionUser();
            vm.userId = user.id;
            vm.currentUserEmail = user.email;
        }

        vm.authUser = {
            email: null, pass: null, checkClauses: null,
        };
        vm.showPassword = false;

        vm.order = {
            coupon: coupon.name || null, cart: [{
                planAlias: $stateParams.alias, qty: 1
            }],
            preview: promoPreview ? {
                promotion: promoPreview.promotion,
                token: promoPreview.token,
                year: promoPreview.year || null
            } : null,
            paymentMethod: null, billing: {
                billingName: infoUser && infoUser.billingName,
                billingFirstname: infoUser && (infoUser.billingFirstname || infoUser.firstname),
                billingLastname: infoUser && (infoUser.billingLastname || infoUser.lastname),
                billingBusinessName: infoUser && infoUser.billingBusinessName,
                billingVat: infoUser && infoUser.billingVat,
                billingCf: infoUser && infoUser.billingCf,
                billingIsEU: infoUser && infoUser.billingIsEU,
                billingPhone: infoUser && infoUser.billingPhone,
                billingAddressCity: infoUser && infoUser.billingAddressCity,
                billingAddressLine1: infoUser && infoUser.billingAddressLine1,
                billingAddressLine2: infoUser && infoUser.billingAddressLine2,
                billingAddressState: infoUser && infoUser.billingAddressState,
                billingAddressZip: infoUser && infoUser.billingAddressZip,
                billingAddressCountry: (infoUser && infoUser.billingAddressCountry) || default_country,
                billingPec: infoUser && infoUser.billingPec,
                billingDestinationCode: infoUser && infoUser.billingDestinationCode,
            }, transaction: null, amount: vm.totalCheckout, currency: 'eur', tax: vm.tax, referral: referral || null
        };

        vm.init = function () {
            vm.isCompany = !!(vm.order && vm.order.billing && (vm.order.billing.billingBusinessName || vm.order.billing.billingVat));
        };

        vm.resetCompanyBillingInfo = function () {
            vm.order.billing.billingBusinessName = null;
            vm.order.billing.billingVat = null;
            vm.order.billing.billingPec = null;
            vm.order.billing.billingDestinationCode = null;
        };

        vm.applyCoupon = applyCoupon;
        vm.$watch('order.billing.billingAddressCountry', function (addressCountry) {
            vm.isItalian = addressCountry.toLowerCase() === 'it';
        });
        vm.$watch('order.billing.billingCf', function (billingCf) {
            if (vm.order && vm.order.billing && vm.order.billing.billingCf) {
                vm.order.billing.billingCf = vm.order.billing.billingCf.toUpperCase();
            }
        });
        vm.$watchGroup(['order.billing.billingFirstname', 'order.billing.billingLastname'], setFullname);
        vm.$watchCollection('coupon.data', getTotal);

        function updateTotal() {
            getTotal();
            if (!vm.isItalian) {
                vm.order.billing.billingAddressState = null;
                vm.order.billing.billingCf = null;
            }

            if (!vm.countries.isEU(vm.order.billing.billingAddressCountry)) {
                //vm.order.billing.billingVat = null;
            }

            if (!vm.isItalian) {
                vm.order.billing.billingPec = null;
            }

            if (!vm.isItalian) {
                vm.order.billing.billingDestinationCode = null;
            }
        }

        vm.$watch('isCompany', updateTotal);
        vm.$watchCollection('order.billing', updateTotal);
        $scope.$on('suiteThemeChanged', function (event, mode, preference) {
            vm.themePreference = preference || SuiteTheme.getPreference();
        });
        $scope.$on('$translateChangeSuccess', function () {
            vm.dateTrialEnd = getDateTrialEnd(plan);
        });
        $scope.$on('event:google-plus-signin-success', function (event, token) {
            loginGoogle(token);
        });
        $scope.$on('event:google-plus-signin-failure', function () {
            vm.socialLoading = null;
            vm.socialError = true;
        });
        $scope.$on('event:google-plus-signin-unavailable', function () {
            vm.socialLoading = null;
            vm.socialError = true;
        });

        vm.coupon = {
            hide: false,
            loading: false,
            error: null,
            data: coupon.data || null,
            name: coupon.name || null,
            open: false,
            discount: 0,
            description: null,
            automatic: false
        };
        applyAutomaticPromo();

        /**
         * Retrieve if exist the value in localstorage
         * otherwise we set on local Storage new one
         * @param {string} key
         * @param {string} value
         */
        function checkOnLocalStorage(key, value) {
            // If key exist on url we check if it same on localstorage
            // if not same update it
            var valueSaved = $window.localStorage.getItem(key);

            if (valueSaved && valueSaved > 0 && valueSaved !== '0' && valueSaved !== '') {
                $window.localStorage.removeItem(key);
                $window.localStorage.setItem(key, value);
            } else {
                // If not exist we add new value on local storage
                $window.localStorage.setItem(key, value);
            }
        }

        function signUser() {
            // Check if user is logged
            if (AuthService.isAuthenticated()) {
                var userId = null;

                if (infoUser && infoUser.id) {
                    userId = infoUser.id;
                }

                vm.userId = userId;
                return $q.resolve(userId);
            }

            // Check credentials
            if (!vm.authUser.email || !vm.authUser.pass) {
                return $q.reject(new Error('invalid input params'));
            }

            var dfd = $q.defer();

            // Try to login user if he is not logged
            AuthService.checkSignin({
                email: vm.authUser.email, pass: vm.authUser.pass,
            })
                .then(function () {
                    return AuthService.signin({
                        email: vm.authUser.email, pass: vm.authUser.pass,
                    });
                })
                .then(function (user) {
                    var userId;

                    // User exist
                    vm.isAuthenticated = true;
                    if (user && user.id) {
                        userId = user.id;
                    }

                    vm.userId = userId;
                    dfd.resolve(userId);
                })
                .catch(function (err) {
                    // Is password wrong
                    if (err && err.message && err.message === 'incorrect password') {
                        dfd.reject(new Error('incorrect password'));
                        return;
                    }

                    // Check if user can register an account
                    AuthService.checkSignup({
                        email: vm.authUser.email, pass: vm.authUser.pass,
                    })
                        .then(function () {
                            return AuthService.signup({
                                email: vm.authUser.email, pass: vm.authUser.pass,
                            });
                        })
                        .then(function () {
                            return AuthService.signin({
                                email: vm.authUser.email, pass: vm.authUser.pass,
                            });
                        })
                        .then(function (user) {
                            var userId;

                            vm.isAuthenticated = true;
                            if (user && user.id) {
                                userId = user.id;
                            }

                            vm.userId = userId;
                            dfd.resolve(userId);
                        })
                        .catch(function (err) {
                            dfd.reject(err);
                        });
                });
            return dfd.promise;
        }

        vm.moneyApproximation = function (num, fixed) {
            var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
            return num.toString().match(re)[0];
        };

        function unsetCoupon() {
            if (vm.coupon.automatic) {
                return;
            }
            vm.coupon.data = null;
            vm.coupon.name = null;
            vm.coupon.error = null;
            vm.order.coupon = null;
            coupon = null;
            $window.localStorage.removeItem('coupon');
            applyAutomaticPromo();
            getTotal();
        }

        function applyCoupon() {
            var code = (vm.order.coupon || '').trim();
            if (!code) {
                unsetCoupon();
                return $q.resolve();
            }

            vm.coupon.error = null;
            vm.coupon.loading = true;
            return CheckoutService.checkCoupon({
                code: code,
                planAlias: plan.alias
            })
                .then(function (res) {
                    vm.coupon.loading = false;
                    vm.coupon.data = res.data;
                    vm.coupon.name = res.data.id || code;
                    vm.coupon.open = false;
                    vm.order.coupon = vm.coupon.name;
                    $window.localStorage.setItem('coupon', vm.coupon.name);
                    getTotal();
                })
                .catch(function () {
                    vm.coupon.loading = false;
                    vm.coupon.data = null;
                    vm.coupon.name = null;
                    vm.coupon.open = true;
                    vm.coupon.error = $translate.instant('upgrade.invalid.coupon');
                    vm.order.coupon = code;
                    $window.localStorage.removeItem('coupon');
                    getTotal();
                });
        }

        function showCouponEditor() {
            vm.coupon.open = true;
            vm.coupon.error = null;
        }

        function getDateTrialEnd(plan) {
            var someDate = new Date();
            var numberOfDaysToAdd = plan.trialPeriodDays || 7;
            someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
            return formatLocalizedDate(someDate);
        }

        function getTrialPriceMessage() {
            return $translate.instant('upgrade.checkout.thenPrice', {
                price: vm.currencySymbol + vm.totalCheckout,
                interval: $translate.instant(plan.interval === 'year' ? 'year' : 'month'),
                date: getDateTrialEnd(plan)
            });
        }

        function getDateSubEnd(plan, isTrial) {
            if (isTrial) {
                vm.dateTrialEnd = getDateTrialEnd(plan);
                return vm.dateTrialEnd;
            }

            var someDate = new Date();
            if (plan.interval === 'year') {
                var d = new Date();
                var year = d.getFullYear();
                var month = d.getMonth();
                var day = d.getDate();
                someDate = new Date(year + 1, month, day);
            } else {
                var numberOfDaysToAdd = 30;
                someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
            }
            return formatLocalizedDate(someDate);
        }

        function formatLocalizedDate(date) {
            var language = $translate.use() || 'en';
            var locale = language.indexOf('-') === -1
                ? LanguageService.getLocaleFromLanguageCode(language)
                : language;
            try {
                return new Intl.DateTimeFormat(locale, {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                }).format(date);
            } catch (error) {
                return $filter('date')(date, 'MMMM d, yyyy');
            }
        }

        vm.onFail = function (message) {
            TrackEventService.event('Funnel Events', 'Payment Failed');
            $state.go('upgrade.failed', {
                alias: $stateParams.alias,
                message: message,
            });
        };

        /**
         *
         * @returns {*}
         */
        vm.onApprove = function () {
            if (!AuthService.isAuthenticated()) {
                $window.console.log(new Error('User not logged in'));
                return;
            }

            var dfd = $q.defer();
            UserService.updateProfile(vm.order.billing)
                .then(function () {
                    vm.loading.payment = true;
                    dfd.resolve();
                })
                .catch(function (err) {
                    dfd.reject(err);
                });

            return dfd.promise;
        };

        /**
         *
         * @param source
         */
        function getCheckoutSession(source) {
            if (!AuthService.isAuthenticated()) {
                $window.console.log(new Error('User not logged in'));
                return;
            }

            vm.loading.payment = true;
            vm.afterPaidLoading = true;
            vm.order.transaction = source;

            UserService.updateProfile(vm.order.billing)
                .then(function () {
                    vm.loading.payment = true;
                    return CheckoutService.getCheckoutSession({
                        order: vm.order
                    });
                })
                .then(function (res) {
                    console.log('getCheckoutSession response', res);

                    if(!res || !res.data || !res.data.data || !res.data.data.sessionLink) {
                        if(res.data.data.error) {
                            vm.onFail(res.data.data.error);
                            return;
                        }

                        vm.onFail('Invalid payment');
                    }

                    CheckoutService.saveCouponOnHistory(vm.order.coupon);
                    $window.location.href = res.data.data.sessionLink;
                })
                .catch(function (err) {
                    var apiError = err && err.data && err.data.error;
                    var failureMessage = apiError && apiError.message ? apiError.message : err.message;

                    console.error('Unable to create checkout session', JSON.stringify({
                        status: err && err.status,
                        statusText: err && err.statusText,
                        errorCode: apiError && apiError.code,
                        message: failureMessage,
                    }));

                    vm.onFail(failureMessage);
                });
        }

        /**
         * @returns {{amount: *, subtotal: *, taxPercent: number, tax: number}}
         */
        function getTotal() {
            if (!vm.price.data) {
                vm.subtotalCheckout = 0;
                vm.tax = 0;
                vm.totalCheckout = 0;
                vm.totalDueToday = 0;
                return;
            }

            vm.order.billing.billingIsEU = CountriesService.isEU(vm.order.billing.billingAddressCountry);
            vm.errorVat = false;
            var baseAmount = Number(plan.amount) || 0;
            var discount = 0;

            if (vm.coupon.data) {
                var percentOff = Number(vm.coupon.data.percent_off_precise || vm.coupon.data.percent_off) || 0;
                if (percentOff > 0) {
                    discount = Math.round(baseAmount * percentOff / 100);
                } else if (vm.coupon.data.amount_off) {
                    discount = Number(vm.coupon.data.amount_off);
                }
            }

            discount = Math.min(baseAmount, Math.max(0, discount));
            vm.coupon.discount = castToPrice(discount);
            var couponPercentage = Number(vm.coupon.data && (vm.coupon.data.percent_off_precise || vm.coupon.data.percent_off));
            vm.coupon.description = vm.coupon.data
                ? (couponPercentage
                    ? couponPercentage + '% ' + $translate.instant('upgrade.checkout.off')
                    : vm.currencySymbol + castToPrice(discount) + ' ' + $translate.instant('upgrade.checkout.off'))
                : null;

            var subtotal = Math.max(0, baseAmount - discount);
            var taxPercent = 0;
            var taxSupply = 0;

            var tax = TaxService.getTax(vm.order.billing.billingAddressCountry, vm.countries.isEU(vm.order.billing.billingAddressCountry), vm.isCompany);

            if (tax > 0) {
                taxPercent = tax / 100;
                vm.thisTax = tax;
                taxSupply = subtotal * taxPercent;
                taxSupply = castIntegerPrice(taxSupply) <= 0 ? 0 : castIntegerPrice(taxSupply);
            } else {
                vm.thisTax = 0;
            }

            var toCharge = subtotal + taxSupply;
            vm.totalCheckout = castToPrice(toCharge) <= 0 ? 0 : castToPrice(toCharge);
            vm.subtotalCheckout = castToPrice(baseAmount) <= 0 ? 0 : castToPrice(baseAmount);
            vm.tax = castToPrice(taxSupply);
            vm.totalDueToday = vm.isTrialing ? '0.00' : vm.totalCheckout;
            return {
                tax: taxSupply,
                taxPercent: taxPercent,
                subtotal: subtotal,
                amount: toCharge
            };
        }

        function loadStripePrice() {
            return CheckoutService.getStripePrice(plan.alias)
                .then(function (res) {
                    var stripePrice = res.data && res.data.data;
                    if (!stripePrice || typeof stripePrice.amount !== 'number') {
                        throw new Error('Invalid Stripe price');
                    }

                    plan.amount = stripePrice.amount;
                    plan.currency = stripePrice.currency;
                    plan.interval = stripePrice.interval;
                    plan.intervalCount = stripePrice.intervalCount;
                    plan.amountDecimal = castToPrice(stripePrice.amount);
                    vm.checkoutPlanName = stripePrice.productName || plan.name;
                    vm.currencySymbol = getCurrencySymbol(stripePrice.currency);
                    vm.order.currency = stripePrice.currency;
                    vm.price.data = stripePrice;
                    vm.price.loading = false;
                    getTotal();
                })
                .catch(function (err) {
                    console.error('Unable to load Stripe price', JSON.stringify({
                        status: err && err.status,
                        errorCode: err && err.data && err.data.error && err.data.error.code,
                    }));
                    vm.price.loading = false;
                    vm.price.error = $translate.instant('upgrade.checkout.priceUnavailable');
                });
        }

        function getCurrencySymbol(currency) {
            return String(currency || 'EUR').toLowerCase() === 'eur'
                ? '€'
                : String(currency || 'EUR').toUpperCase();
        }

        function hasOrderTax() {
            return vm.isItalian || (!vm.isItalian && (!vm.order.billing.billingBusinessName || vm.order.billing.billingBusinessName.trim() === ''));
        }

        function setFullname() {
            var lastname = vm.order.billing.billingLastname || '';
            var firstname = vm.order.billing.billingFirstname || '';
            vm.order.billing.billingName = (firstname + " " + lastname).trim();
        }

        function castToPrice(x) {
            return parseFloat((x / 100).toFixed(2)).toFixed(2);
        }

        function castIntegerPrice(x) {
            return parseInt(parseFloat(x).toFixed(0));
        }

        function goToBillingDetails() {
            transitionToBillingDetails();
        }

        function transitionToBillingDetails() {
            vm.steps.country.show = false;
            vm.steps.country.exist = false;
            vm.steps.details.hide = false;
            $timeout(function () {
                vm.steps.details.exist = true;
                vm.steps.details.show = true;
            }, 400);
        }

        vm.resetPayment = resetPayment;

        function resetPayment() {
            vm.order.paymentMethod = null;
        }

        vm.logout = function () {
            AuthService.logout();

            $window.setTimeout(function () {
                $state.go($state.current, {}, {
                    reload: true
                });
            }, 200);
        };

        function enableQuickLogin() {
            vm.quickLoginMode = true;
            if (vm.billingForm && vm.billingForm.pass) {
                vm.billingForm.pass.$setValidity('incorrect-password', true);
            }
            $timeout(function () {
                var emailField = $window.document.getElementById('email');
                if (emailField) {
                    emailField.focus();
                }
            }, 0, false);
        }

        function enableSignup() {
            vm.quickLoginMode = false;
            vm.showPassword = false;
            vm.socialError = false;
            if (vm.billingForm && vm.billingForm.pass) {
                vm.billingForm.pass.$setValidity('incorrect-password', true);
            }
        }

        function loginFacebook() {
            if (!Facebook.isReady() || vm.socialLoading) {
                return;
            }
            vm.socialLoading = 'facebook';
            vm.socialError = false;
            Facebook.login(function (response) {
                if (response.status !== 'connected') {
                    vm.socialLoading = null;
                    return;
                }
                AuthService.facebookSignin({
                    lang: $translate.use() || 'en',
                    access_token: response.authResponse.accessToken
                }).then(completeSocialSignin).catch(handleSocialSigninError);
            }, {scope: 'email,public_profile'});
        }

        function loginGoogle(token) {
            if (!token || vm.socialLoading) {
                return;
            }
            vm.socialLoading = 'google';
            vm.socialError = false;
            AuthService.googleSignin({
                lang: $translate.use() || 'en',
                access_token: token
            }).then(completeSocialSignin).catch(handleSocialSigninError);
        }

        function completeSocialSignin(response) {
            var user = response && response.data && response.data.user;
            if (user && (!user.businessType || !user.teamMembers || !user.jobTitle)) {
                vm.socialLoading = null;
                $state.go('access.tailor-made');
                return;
            }

            return $state.go($state.current, $stateParams, {reload: true}).finally(function () {
                vm.socialLoading = null;
            });
        }

        function handleSocialSigninError(err) {
            console.log(err);
            vm.socialLoading = null;
            vm.socialError = true;
        }

        function quickSignin() {
            if (vm.authLoading || !vm.authUser.email || !vm.authUser.pass) {
                return;
            }

            vm.authLoading = true;
            if (vm.billingForm && vm.billingForm.pass) {
                vm.billingForm.pass.$setValidity('incorrect-password', true);
            }

            return AuthService.signin({
                email: vm.authUser.email,
                pass: vm.authUser.pass
            }).then(function () {
                return $state.go($state.current, $stateParams, {reload: true});
            }).catch(function (err) {
                if (vm.billingForm && vm.billingForm.pass) {
                    vm.billingForm.pass.$setValidity('incorrect-password', false);
                    vm.billingForm.pass.$setTouched();
                }
                console.log(err);
            }).finally(function () {
                vm.authLoading = false;
            });
        }

        vm.goToPayment = function () {
            if (!vm.billingForm.$valid || vm.price.loading || vm.price.error || vm.coupon.loading
                || (vm.order.coupon && !vm.coupon.data)) {
                return;
            }

            var dfd = $q.defer();

            console.log('Start to signin');
            signUser()
                .then(function () {
                    console.log('Get checkout session');
                    return getCheckoutSession();
                })
                .then(function () {
                    TrackEventService.event('Funnel Events', 'Open Stripe Dialog', plan.alias);
                    TrackEventService.gaV2Event('open_stripe_dialog');
                    dfd.resolve();
                })
                .catch(function (err) {
                    console.log(err);

                    if (err.message) {
                        if (err.message === 'password too short') {
                            vm.billingForm.pass.$setValidity('minlength', false);
                        }

                        if (err.message === 'incorrect password') {
                            vm.billingForm.pass.$setValidity('incorrect-password', false);
                        }
                    }

                    dfd.reject(err);
                });

            return dfd.promise;
        };

        vm.removePasswordError = function () {
            vm.billingForm.pass.$setValidity('incorrect-password', true);

            if (vm.authUser.pass && vm.authUser.pass.length >= 8) {
                vm.billingForm.pass.$setValidity('minlength', true);
            }
        };

        function cycleThemePreference() {
            var preferences = ['light', 'dark', 'system'];
            var currentIndex = preferences.indexOf(SuiteTheme.getPreference());
            SuiteTheme.setPreference(preferences[(currentIndex + 1) % preferences.length]);
            vm.themePreference = SuiteTheme.getPreference();
        }

        function switchLang(language) {
            vm.selectedLang = language;
            $rootScope.setLang(language);

            if (!vm.isAuthenticated) {
                return;
            }

            UserService.updateProfile({locale: language})
                .catch(function (err) {
                    console.log(err);
                });
        }

        function removePromoCouponIfExpired() {
            var promo = PlanDetailsService.getCurrentPromo();
            var storedCoupon = $window.localStorage.getItem('coupon');
            if (promo
                && storedCoupon
                && /^(BLACKFRIDAY|CYBERMONDAY|CHRISTMAS)\d{4}$/i.test(storedCoupon)) {
                $window.localStorage.removeItem('coupon');
            }
        }

        function applyAutomaticPromo() {
            var promo = PlanDetailsService.getCurrentPromo();
            if (!promo
                || vm.coupon.data
                || (promo.annualOnly && plan.interval !== 'year')) {
                return;
            }

            vm.coupon.data = {
                automatic: true,
                percent_off: promo.discount
            };
            vm.coupon.name = promo.name;
            vm.coupon.automatic = true;
        }

        if (vm.isAuthenticated) {
            CRMService.addEvents(['UserToTrialGenericCheckoutRecoverEvent'], [
                'UserToTrialPricingRecoverEvent',
            ]);
        }

        loadStripePrice();
    }

    Controller.$inject = ['$rootScope', '$scope', '__env', '$timeout', '$state', '$stateParams', 'UserService', 'CountriesService', 'TaxService', 'CheckoutService', 'plan', 'info', 'isTrialing', '$translate', '$filter', 'coupon', '$window', 'ItalyService', '$cookies', '$q', 'TrackEventService', '$mdMedia', 'AuthService', 'Facebook', 'PlanDetailsService', 'LanguageService', 'SuiteTheme', 'CRMService'];

    return Controller;
});
